import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-read-more',
  standalone:true,
  imports:[CommonModule],
  templateUrl: './read-more.component.html',
  styleUrls: ['./read-more.component.scss']
})
export class ReadMoreComponent {
  @Input() text: string = '';
  @Input() uniqueId: string = '';
  id=''
  @Output() viewMore=new EventEmitter()
      @Input() maxLength: number = 20;
      showReadMore: boolean = false;
      isExpanded: boolean = false;
      truncatedText: string = '';

      ngOnChanges(changes: SimpleChanges): void {
        if (changes['text']) {
          this.truncatedText = this.text.slice(0, this.maxLength);
          this.showReadMore = this.text.length > this.maxLength;
        }
        if (changes['uniqueId']) {
          this.id = this.uniqueId
        }
      }
ngOnInit(){
  this.truncatedText = this.text.slice(0, this.maxLength);
          this.showReadMore = this.text.length > this.maxLength;
       
          
  
}
      toggleView(): void {
        this.isExpanded = !this.isExpanded;
      }
      
      viewMoredata(){
        this.viewMore.next(this.text)
      }

}
